import { render, staticRenderFns } from "./CardIcons.vue?vue&type=template&id=615d5174&lang=pug"
import script from "./CardIcons.vue?vue&type=script&lang=js"
export * from "./CardIcons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports